import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18MemberSolidG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      transform: "translate(3 3)",
      children: [/*#__PURE__*/jsx("path", {
        d: "M6 6c3.24 0 5.88 1.496 5.996 3.367L12 10.685c0 1.109-.79 1.218-1.795 1.304l-.02.011h-8.37l-.02-.011C.79 11.903 0 11.794 0 10.685v-1.19C0 7.608 2.568 6.07 5.78 6.002z"
      }), /*#__PURE__*/jsx("circle", {
        cx: 6,
        cy: 2.571,
        r: 2.571
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18MemberSolidG$1 = Svg18MemberSolidG;

export { Svg18MemberSolidG$1 as default };
